module.exports = __webpack_public_path__ + "static/media/Illus-LoyaltyBloom.5de290cd.png";